import { Building, Thermometer, Shield, Wrench, Zap } from 'lucide-react';
import { Product } from './types';

export const facilitiesProducts: Product[] = [
  {
    id: 'security-surveillance-management',
    title: 'Security & Surveillance Management',
    subtitle: 'Comprehensive security solution',
    description: 'Advanced security management with video surveillance, access control, incident tracking, and real-time monitoring.',
    icon: Shield,
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Facilities Management',
    status: 'Available',
    features: [
      'Video surveillance',
      'Access control',
      'Incident management',
      'Real-time alerts',
      'Visitor management',
      'Integration capabilities',
      'Mobile monitoring',
      'Compliance reporting'
    ],
    pricing: { setup: 38000, monthly: 1748 },
    color: 'from-red-500 to-pink-600',
    businessTypes: ['#security', '#surveillance', '#facilities', '#safety', '#monitoring']
  },
  {
    id: 'hvac-control-monitoring',
    title: 'HVAC Control & Monitoring System',
    subtitle: 'Smart climate management',
    description: 'Intelligent HVAC control system with energy optimisation, predictive maintenance, and comprehensive environmental monitoring compliant with UK building regulations and HSE standards.',
    icon: Thermometer,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Facilities Management',
    status: 'Available',
    features: [
      'Smart temperature control',
      'Energy optimisation with UK building regulations compliance',
      'Predictive maintenance',
      'Remote monitoring',
      'Environmental sensors',
      'Automated scheduling',
      'Performance analytics',
      'Cost tracking'
    ],
    pricing: { setup: 35000, monthly: 1610 },
    color: 'from-blue-500 to-cyan-600',
    businessTypes: ['#hvac', '#facilities', '#energy', '#automation', '#monitoring']
  },
  {
    id: 'remote-facility-monitoring',
    title: 'Remote Facility Monitoring System',
    subtitle: 'Comprehensive facility oversight',
    description: 'Complete remote monitoring solution for facilities with real-time data, alerts, and comprehensive reporting.',
    icon: Building,
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Facilities Management',
    status: 'Available',
    features: [
      'Real-time monitoring',
      'Multi-site management',
      'Alert systems',
      'Performance tracking',
      'Energy management',
      'Maintenance scheduling',
      'Mobile access',
      'Custom dashboards'
    ],
    pricing: { setup: 36000, monthly: 1656 },
    color: 'from-purple-500 to-indigo-600',
    businessTypes: ['#facilities', '#monitoring', '#remote', '#management', '#automation']
  },
  {
    id: 'predictive-maintenance-platform',
    title: 'Predictive Maintenance Platform',
    subtitle: 'AI-driven maintenance',
    description: 'Advanced predictive maintenance solution with machine learning algorithms for asset performance monitoring and failure prediction.',
    icon: Wrench,
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Facilities Management',
    status: 'Available',
    features: [
      'Machine learning models',
      'Asset performance monitoring',
      'Failure prediction',
      'Maintenance scheduling',
      'Real-time alerts',
      'Reporting tools',
      'Mobile access',
      'Integration capabilities'
    ],
    pricing: { setup: 45000, monthly: 2070 },
    color: 'from-orange-500 to-red-600',
    businessTypes: ['#maintenance', '#predictive', '#ai', '#facilities', '#asset-management']
  },
  {
    id: 'energy-management-system',
    title: 'Energy Management System',
    subtitle: 'Sustainable energy solutions',
    description: 'Comprehensive energy management system with real-time monitoring, optimisation algorithms, and sustainability reporting compliant with UK environmental regulations.',
    icon: Zap,
    image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Facilities Management',
    status: 'Available',
    features: [
      'Real-time energy monitoring',
      'Optimisation algorithms with UK energy efficiency standards',
      'Sustainability reporting',
      'Automated controls',
      'Demand response',
      'Renewable energy integration',
      'Cost tracking',
      'Compliance management'
    ],
    pricing: { setup: 40000, monthly: 1840 },
    color: 'from-yellow-500 to-lime-600',
    businessTypes: ['#energy', '#sustainability', '#facilities', '#optimization', '#monitoring']
  }
];
